<template>
  <MainNav v-if="$route.name === DASHBOARD || $route.name === CLUB_TAB" />
  <RouterView />
</template>

<script setup lang="ts">
import MainNav from '@/modules/club/components/MainNav.vue'
import { CLUB_TAB, DASHBOARD } from '@/modules/club/routes'
</script>
